// TODO 待完善
import moment from 'moment';
import { BusinessHour2, MenuDish, NewMenuPrice } from '../models';
import { v4 as uuid } from 'uuid'
import * as xlsx from 'xlsx'
import i18n from '../i18n';
import { getCurrencyName } from './tool.fn';
// import { useTranslation } from 'react-i18next';

/**
 *  比较时间大小
 */
export function timeDifference(time1: string, time2: string) {
    return moment(time1, 'HH:mm').diff(moment(time2, 'HH:mm'), 'm')
}

/**
 * 时间显示 距离现在的时间
 * @param date 时间
 * @returns
 */
export function fToNow(date?: Date) {
    return date ? moment(date).fromNow() : ''
}

/**
 * 时间显示（非法时间返回空串，避免 `Invalid date` 出现在 UI）。
 * @param date - 支持 `Date`、ISO 字符串、Unix 时间戳（毫秒或秒）
 * @param format - moment 格式串，如 `MM/DD/YYYY`
 * @returns 格式化文案；无值或无法解析时返回 `''`
 */
export function dateFormat(date?: Date | string | number, format = 'YYYY-MM-DD') {
    if (date == null || date === '') {
        return '';
    }
    const m = moment(date);
    return m.isValid() ? m.format(format) : '';
}

/**
 * 反选
 * @param array
 * @param value
 */
export function toggle<T extends string | number>(array: T[], value: T): T[] {
    const index = array.indexOf(value);
    if (index < 0) {
        array.push(value)
    } else {
        array.splice(index, 1)
    }
    return array
}

/**
 * 反选，对象数组
 * @param array 
 * @param obj 
 * @param key 
 * @returns 
 */
export function toggleInObjectArray<T extends { [key: string]: any }>(
    array: T[],
    obj: T,
    key: keyof T
): T[] {
    const index = array.findIndex(item => item[key] === obj[key]);
    if (index === -1) {
        return [...array, obj];
    } else {
        return [
            ...array.slice(0, index),
            ...array.slice(index + 1)
        ];
    }
}


/**
 * 菜单新价格方案
 * - 空表单
 * @param extraMenuData
 * @returns
 */
export function setEmptyNewPriceForm(extraMenuData: MenuDish[]) {
    // 额外费用菜单列表
    const extraMenuDataOptions = extraMenuData.map((item) => ({
        label: `${item.item_id}. ${item.item_name1}: ${item.price_1} ${getCurrencyName()}`,
        value: `${item.item_id}`
    }))

    const formArr = [
        {
            key: 'extra_normal',
            label: i18n.t('normal_price'),
            options: extraMenuDataOptions,
            inputType: 'SELECT_MUL',
            value: [],
            other: 'normal_price'
        },
        {
            key: 'extra_child',
            label: i18n.t('child_price'),
            options: extraMenuDataOptions,
            inputType: 'SELECT_MUL',
            value: [],
            other: 'child_price'
        },
        {
            key: 'extra_other',
            label: i18n.t('other_price'),
            options: extraMenuDataOptions,
            inputType: 'SELECT_MUL',
            value: [],
            other: 'other_price'
        },
    ]
    return formArr
}


/**
 * 菜单新价格方案
 * - 空菜单价格（周一至周日）
 */
export function setEmptyNewPriceValue() {
    const emptyValues = [1, 2, 3, 4, 5, 6, 0].map(n => {
        const params: NewMenuPrice = {
            // 星期数
            week: n,
            // 儿童价格 额外费用信息 id
            extra_child: '',
            //  成人价格 额外费用信息 id
            extra_normal: '',
            //  其他价格 额外费用信息 id
            extra_other: '',
            // 正常价格
            normal_price: null,
            // 儿童价格
            child_price: null,
            // 其他价格
            other_price: null,
        }
        return params
    })

    return emptyValues
}

// T中P属性的类型
export type PropType<T, P extends keyof T> = T[P];

/**
 * 新建数据时是从前端传id过去
 * 寻找最合适的id
 * 比如现在存在的id数组[1,2,3,5]
 * 最合适的id就是4
 * 最小是1
 * 缺失的第一个正数
 * https://leetcode-cn.com/problems/first-missing-positive/submissions/
 * @param arr number[]
 * @returns number 最合适的id
 */
export function firstMissingPositive(arr: number[]): number {
    for (let i = 0; i < arr.length; i++) {
        while (
            arr[i] >= 1 &&
            // 仅对小于数组长度的数组进行交换
            arr[i] <= arr.length &&
            // 出现理想位置的，不需要交换
            arr[arr[i] - 1] !== arr[i]
        ) {
            const temp = arr[arr[i] - 1]
            arr[arr[i] - 1] = arr[i]
            arr[i] = temp
        }
    }
    // 交换完，得到理想正数的数组，可以找到缺少的数组
    for (let i = 0; i < arr.length; i++) {
        if (arr[i] !== i + 1) {
            return i + 1
        }
    }
    return arr.length + 1
}

/**
 * 返回星期
 * @param date
 * @returns
 */
export function getDate(date: number) {
    const weeks = new Map([
        [1, i18n.t('business_hour_page_Monday')],
        [2, i18n.t('business_hour_page_Tuesday')],
        [3, i18n.t('business_hour_page_Wednesday')],
        [4, i18n.t('business_hour_page_Thursday')],
        [5, i18n.t('business_hour_page_Friday')],
        [6, i18n.t('business_hour_page_Saturday')],
        [0, i18n.t('business_hour_page_Sunday')],
        [7, i18n.t('menu_library_create_dialog_week_holiday')],
    ])
    return weeks.get(date)
}

/**
 * 生成营业时间数据
 * @param date 2021-10-12' 或者 '0-6' 0周日 6周六 星期或者日期
 * @param type 营业时间的类型（0：星期 + 时间；1：日期 + 时间；）
 * @param defaultTurnDishes 每人每轮点餐数量默认值
 * @param defaultTurnMins 每人每轮点餐时间默认值
 * @param defaultMaxRound 最大轮数默认值
 */
export function generateBusinessHour2(date: string, type: string, defaultTurnDishes: number, defaultTurnMins: number, defaultMaxRound: number) {
    const data: BusinessHour2 = {
        id: uuid(),
        date,
        pattern: '1',
        type,
        value: [
            {
                id: 1,
                data_type: '0',
                default_menu: [],
                hide_menu: [],
                preferred_menu: [],
                alternative_menu: [],
                end_time: '24:00',
                start_time: '00:00',
                value: '0',
                project: [],
                selftake_status: '0',
                takeaway_status: '0',
                turn_dishes: defaultTurnDishes,
                turn_mins: defaultTurnMins,
                max_turn: defaultMaxRound,
            }
        ],
        value2: [
            {
                id: 1,
                data_type: '1',
                default_menu: [],
                hide_menu: [],
                preferred_menu: [],
                alternative_menu: [],
                end_time: '24:00',
                start_time: '00:00',
                value: '1',
                project: [],
                selftake_status: '0',
                takeaway_status: '0',
                turn_dishes: defaultTurnDishes,
                turn_mins: defaultTurnMins,
                max_turn: defaultMaxRound,
            }
        ]
    }
    return data
}

const COLUMN_LABEL_BASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const COLUMN_LABEL_BASE_LENGTH = COLUMN_LABEL_BASE.length;

/**
 * 根据列头名返回具体索引
 * 如 A: 0, B: 1, AA: 26
 * @param label 列头名
 * @returns
 */
const spreadsheetColumnIndex = (label: string) => {
    let result = 0
    if (label) {
        for (let i = 0, j = label.length - 1; i < label.length; i += 1, j -= 1) {
            result += Math.pow(COLUMN_LABEL_BASE_LENGTH, j) * (COLUMN_LABEL_BASE.indexOf(label[i]) + 1)
        }
    }
    result -= 1
    return result
}

/**
 * 导出excel
 * @param sheetData 表数据
 * @param downloadName 下载名称
 */
export function export2Excel(sheetData: sheetDataType, downloadName: string) {
    const book = xlsx.utils.book_new()
    sheetData.forEach(item => {
        const sheet = xlsx.utils.json_to_sheet(item.data)
        if (item.colConfig) {
            const colKeys = Object.keys(item.colConfig)
            const sheetKeys = Object.keys(sheet)
            sheet['!cols'] = [];
            colKeys.forEach(colkey => {
                const cell = sheetKeys.find(sk => sheet[sk]?.v === colkey)
                if (cell) {
                    const index = spreadsheetColumnIndex(cell.slice(0, -1));
                    if (sheet['!cols']) {
                        sheet['!cols'][index] = item?.colConfig?.[colkey] || {};
                    }
                }
            })
        }
        xlsx.utils.book_append_sheet(book, sheet, item.sheetName)
    })
    const wbout = xlsx.write(book, {
        bookType: 'xlsx',
        bookSST: false,
        type: 'binary'
    });
    function s2ab(s: string) {
        const buf = new ArrayBuffer(s.length);
        const view = new Uint8Array(buf);
        for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
        return buf;
    }
    const blob = new Blob([s2ab(wbout)], {
        type: 'application/octet-stream'
    });
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = `${downloadName}.xlsx`
    a.click()
}

export type sheetDataType = Array<{ data: any[], sheetName: string, colConfig?: { [colName: string]: xlsx.ColInfo } }>

/**
 * 解析excel
 * @param file excel
 * @returns { Promise } fulfilled value { data: [], sheetName: '' }
 */
export function excel2JSON(file: File) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsBinaryString(file)
        reader.onload = (e) => {
            const data = e?.target?.result
            if (data) {
                const wb = xlsx.read(data, { type: 'binary' })
                const result: any[] = []
                wb.SheetNames.forEach(name => {
                    result.push({
                        data: xlsx.utils.sheet_to_json(wb.Sheets[name], { raw: false, header: 1 }),
                        sheetName: name
                    })
                })
                resolve(result)
            } else {
                resolve([])
            }
        }
        reader.onerror = () => reject(new Error('解析出错'))
    })
}

// 日期格式化，日期加上星期几
export function formatDateWithWeekday(date: string) {
    if (!date) {
        return ''
    }
    // 星期
    const weekday = moment(date).format('dddd');
    // 将英文星期转换为i18n国际化的星期
    const weekdayKey = `business_hour_page_${weekday}`;
    const week = i18n.t(weekdayKey);
    // 格式化日期
    const formattedDate = moment(date).format('YYYY/MM/DD');
    return `${formattedDate} ${week}`
}
